<template>
  <div>
    <div class="actions-bar-wrapper" :class="theme">
      <van-row justify="center" :class="`cols-${colSpan}`">
        <template v-if="loginRegisterTypes.length > 1">
          <van-col :span="colSpan" v-if="isAccount">
            <div class="item" @click="toAuthTypeDialog('account')">
              <div class="svg_box flex-center">
                <SvgIcon icon-name="user" :width="49" :height="55" />
              </div>
              <span class="label">{{ accountLabel }}</span>
            </div>
          </van-col>
          <van-col :span="colSpan" v-if="isPhone">
            <div class="item" @click="toAuthTypeDialog('phone_captcha')">
              <div class="svg_box flex-center">
                <SvgIcon icon-name="sub_phone" :width="44" :height="61" />
              </div>
              <span class="label">{{ phoneLabel }}</span>
            </div>
          </van-col>
          <van-col :span="colSpan" v-if="isEmail">
            <div class="item" @click="toAuthTypeDialog('email_captcha')">
              <div class="svg_box flex-center">
                <SvgIcon icon-name="sub_mail" :width="51" :height="45" />
              </div>
              <span class="label">{{ emailLabel }}</span>
            </div>
          </van-col>
        </template>
        <van-col :span="colSpan">
          <div class="item" @click="goHome">
            <div class="svg_box flex-center">
              <SvgIcon icon-name="sub_game" :width="54" :height="51" />
            </div>
            <span class="label">免费试玩</span>
          </div>
        </van-col>
        <van-col :span="colSpan">
          <div class="item" @click="goService">
            <div class="svg_box flex-center">
              <SvgIcon icon-name="sub_server" :width="58" :height="54" />
            </div>
            <span class="label">在线客服</span>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs, useAppStore, useTenantStore, useUserStore } from '@star/stores';
import { mb_t } from '@star/languages';
import { includes, keys, pickBy } from 'lodash-es';

type Props = {
  loginWay: string;
  registerWay: string;
  type: number;
};

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['success', 'checkAuthWay']);
const router = useRouter();
const { showLogin } = useUserStore();
const { theme } = storeToRefs(useAppStore());
const { sysLoginOptions, sysRegisterOptions, loginMode, registerMode } = storeToRefs(useTenantStore());
const LOGIN_TYPES = ['account', 'phone_captcha', 'email_captcha', 'email_pwd_captcha'];
const REGISTER_TYPES = ['account', 'phone_captcha', 'email_captcha'];

const phoneLabel = computed(() => {
  return mb_t(props.type === 1 ? '手机登录' : '手机注册');
});

const accountLabel = computed(() => {
  return mb_t(props.type === 1 ? '账号登录' : '账号注册');
});

const emailLabel = computed(() => {
  return mb_t(props.type === 1 ? '邮箱登录' : '邮箱注册');
});

// 可登录注册类型
const loginRegisterTypes = computed(() => {
  console.log(sysRegisterOptions.value, 'vvvvvvvvvvvvvvvvvvvvv');
  return props.type === 1
    ? keys(pickBy(sysLoginOptions.value?.CUST_LOGIN_MODE, (value, key) => includes(LOGIN_TYPES, key) && value === '1'))
    : keys(
        pickBy(
          sysRegisterOptions.value?.CUST_REGISTER_MODE,
          (value, key) => includes(REGISTER_TYPES, key) && value === '1'
        )
      );
});

const way = computed(() => {
  return props.type === 1 ? props.loginWay : props.registerWay;
});

const isAccount = computed(() => {
  return includes(loginRegisterTypes.value, 'account') && way.value !== 'account';
});

const isPhone = computed(() => {
  return includes(loginRegisterTypes.value, 'phone_captcha') && way.value !== 'phone_captcha';
});

const isEmail = computed(() => {
  return (
    (includes(loginRegisterTypes.value, 'email_captcha') || includes(loginRegisterTypes.value, 'email_pwd_captcha')) &&
    !(way.value == 'email_captcha' || way.value == 'email_pwd_captcha')
  );
});

const colSpan = computed(() => {
  return loginRegisterTypes.value.length > 2 ? 6 : loginRegisterTypes.value.length > 1 ? 8 : 12;
});

const toAuthTypeDialog = (wayType: string) => {
  emit('checkAuthWay', { type: props.type, value: wayType });
};

const goService = () => {
  showLogin({ type: 0 });
  router.push('/services');
};

const goHome = () => {
  showLogin({ type: 0 });
  router.push('/trial');
};
</script>

<style lang="less" scoped>
.actions-bar-wrapper {
  padding: 60px 40px 100px;

  .van-row {
    &.cols-8 {
      padding: 0 60px;
    }

    &.cols-12 {
      padding: 0 150px;
    }
  }

  .item {
    width: 200px;
    padding: 24px 0;
    text-align: center;
    background: linear-gradient(180deg, #f6f6f6 0%, #fff 100%);
    border-radius: 42px;
    margin: 0 auto;

    .svg_box {
      height: 90px;
      margin-bottom: 15px;
    }

    .label {
      font-size: 34px;
      font-weight: 400;
      color: #b7b7b7;
      line-height: 1.2;
    }
  }

  &.dark {
    padding: 0 40px 30px;

    .item {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;

      .svg_box {
        height: auto;
        margin-bottom: 0;
      }

      .svg-icon {
        font-size: 36px;
      }

      .label {
        font-size: 39px;
        margin-left: 15px;
        color: var(--text-color-2);
      }
    }
  }
}
</style>
